<template>
    <div id="app wrap">
        <div class="header">
            <a href="javascript:;" class="page_back" @click="onClickBack" v-if="isNotMain">이전</a>
            <h1>{{pageTitle}}</h1>
            <router-link to="/" class="home" v-if="isNotMain">홈으로</router-link>
        </div>

        <!-- transition :name="transitionName" mode="in-out" -->
            <router-view></router-view>
        <!-- /transition -->
    </div>
</template>

<script>
require('@/assets/css/reset.css')
require('@/assets/css/common.css')
require('@/assets/css/dev.css')

export default {
    name: 'App',
    data() {
        return {
            pageTitle: '포스코이앤씨 신고/상담센터' //포스코이앤씨 신고·상담센터'
        }
    },
    watch: {
        $route(a, b) {
            if (a.name == 'write') {
                this.setPageTitle(a.params.flag)
            } else {
                this.setPageTitle(a.name)
            }
        }
    },
    computed: {
        transitionName() {
            return this.$store.state.transition
        },
        isNotMain() {
            return this.$route.path != '/' ? true : false
        }
    },
    created() {
        if (process.env.NODE_ENV == 'production') {
            document.addEventListener('deviceready', () => {
                this.$store.commit('setDeviceReady', true)

                // 화면 세로 고정
                window.screen.orientation.lock('portrait')

                // android backbutton 설정
                document.addEventListener('backbutton', evt => {
                    const fullPopup = document.body.querySelectorAll('.full-popup').length

                    // 팝업형태의 component가 떠 있는 상황이 아닌 경우
                    if (fullPopup == 0) {
                        if (this.$route.name == 'index') {
                            this.$confirm({
                                msg: this.pageTitle + ' 앱을 종료 하시겠습니까?',
                                title: '앱 종료',
                                buttons: ['종료', '취소'],
                                callback: function(index) {
                                    if (index === 1) {
                                        navigator.app.exitApp()
                                    }
                                }
                            })
                        } else {
                            this.$store.commit('setTransition', 'content-back')
                            this.$router.go(-1)
                            setTimeout(() => {
                                this.$store.commit('setTransition', 'content-slide')
                            }, 300)
                        }
                    }
                }, false)
            }, false)
        }
    },
    methods: {
        onClickBack($evt) {
            $evt.preventDefault()

            this.$store.commit('setTransition', 'content-back')
            this.$router.go(-1)

            setTimeout(() => {
                this.$store.commit('setTransition', 'content-slide')
            }, 300)
        },
        setPageTitle(flag) {
            switch (flag) {
                case 'ethics': this.pageTitle = '업무비윤리 신고'; break
                case 'gab': this.pageTitle = '갑질행위 신고'; break
                case 'office': this.pageTitle = '직장내 괴롭힘·성희롱 신고'; break
                case 'unfair': this.pageTitle = '불공정거래 신고'; break
                case 'praise': this.pageTitle = '칭찬하기'; break
                case 'worker': this.pageTitle = '현장근로자 소리함'; break
                case 'resultLogin':
                case 'resultList': this.pageTitle = '처리결과확인'; break
                default: this.pageTitle = '포스코이앤씨 신고/상담센터'
            }
        }
    }
}
</script>

<style>
.content-slide-enter {left: 100%; top: 0; position: absolute; background-color: #fff; width: 100vw; height: 100vh;}
.content-slide-enter-to {left: 0; top: 0; position: absolute; background-color: #fff; width: 100vw; height: 100vh;}

.content-slide-leave {display: none;}
.content-slide-leave-to {display: none;}

.content-back-enter {left: -100%; top: 0; position: absolute; background-color: #fff; width: 100vw; height: 100vh;}
.content-back-enter-to {left: 0; top: 0; position: absolute; background-color: #fff; width: 100vw; height: 100vh;}
.content-back-leave {display: none;}
.content-back-leave-to {display: none;}

.content-slide-enter-active, .content-slide-leave-active, .content-back-enter-active, .content-back-leave-active {transition: all .2s ease;}
</style>



// WEBPACK FOOTER //
// src/App.vue